import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { MaterialModel, MaterialModelPagedResponseModel } from '../models';
import { ApiConfigService } from './api-config.service';

@Injectable({
    providedIn: 'root'
})
export class MaterialsService extends BaseApiService {

    constructor( http: HttpClient,
           apiConfig: ApiConfigService) {
           super(http, apiConfig);
       }
       baseUrl = this.apiConfig.getBaseUrl();

    /**
     * Get all materials with pagination
     */
    getMaterials(page: number = 1, pageSize: number = 20, materialId?: string, materialName?: string): Observable<MaterialModelPagedResponseModel> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        if (materialId) {
            params = params.set('materialId', materialId);
        }
        if (materialName) {
            params = params.set('materialName', materialName);
        }

        return this.http.get<MaterialModelPagedResponseModel>(`${this.baseUrl}/api/v1/materials`, { params });
    }

    /**
     * Get material by ID
     */
    getMaterial(id: string): Observable<MaterialModel> {
        return this.http.get<MaterialModel>(`${this.baseUrl}/api/v1/materials/${id}`);
    }

    /**
     * Create new material
     */
    createMaterial(material: MaterialModel): Observable<MaterialModel> {
        return this.http.post<MaterialModel>(`${this.baseUrl}/api/v1/materials`, material);
    }

    /**
     * Update material
     */
    updateMaterial(id: string, material: MaterialModel): Observable<MaterialModel> {
        return this.http.put<MaterialModel>(`${this.baseUrl}/api/v1/materials/${id}`, material);
    }

    /**
     * Delete material
     */
    deleteMaterial(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/api/v1/materials/${id}`);
    }

    /**
     * Get material by material ID
     */
    getMaterialByMaterialId(materialId: string): Observable<MaterialModel> {
        return this.http.get<MaterialModel>(`${this.baseUrl}/api/v1/materials/material-id/${materialId}`);
    }

    /**
     * Search materials
     */
    searchMaterials(searchTerm: string): Observable<MaterialModel[]> {
        return this.http.get<MaterialModel[]>(`${this.baseUrl}/api/v1/materials/search?searchTerm=${searchTerm}`);
    }
}
